import React from 'react';
import useBundleTranslation from 'i18n';
import { ActionMenuItem } from 'components/common/action-menu/ActionMenu';
import useWallContext from 'components/wall/hooks/useWallContext';
import { useEmbeddingContextVisible } from 'hooks/useEmbeddingContext';

export default function ExpertAnalysis() {
    const { t } = useBundleTranslation(['components/wall/wall']);

    const { wallActions } = useWallContext(false);
    const handleOnClick = () => {
        wallActions.setExpertAnalysisField(true);
    };

    const hasMenuIcon = useEmbeddingContextVisible('action_select_buttons.expert_analysis');
    if (!hasMenuIcon) {
        return null;
    }

    return (
        <ActionMenuItem
            label={t('expert_analysis.add_link')}
            desc={t('expert_analysis.desc')}
            icon="expert-analysis"
            onClick={handleOnClick}
        />
    );
}
